var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 10,
    fill: "#81D61E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_948_12312)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_948_12312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 39,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H48V48H9V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_948_12312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1714 46.5537H14.1618V18.2202C14.1618 17.4259 14.669 16.7204 15.4219 16.4673L31.1714 11.1734V46.5537Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7445 42.9995V46.5537H31.1713V27.3576H41.734C42.434 27.3576 43.0008 27.9244 43.0008 28.6244V38.7857",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1714 46.5537H46.5697C47.0441 46.5537 47.4287 46.1692 47.4287 45.6948V42.9997H31.1714V46.5537Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9253 38.6482H44.2478C46.0045 38.6482 47.4286 40.0723 47.4286 41.829V42.9996H40.7445V41.829C40.7445 40.0723 42.1686 38.6482 43.9253 38.6482Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4303 46.5535H14.1619V42.9994H9.57135V45.6946C9.57135 46.169 9.95587 46.5535 10.4303 46.5535Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7127 38.6482H14.1619V42.9996H9.57123V42.7897C9.57123 40.5024 11.4255 38.6482 13.7127 38.6482Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0863 27.3573H31.1714V11.1734L36.5223 16.3457C36.8828 16.6941 37.0863 17.174 37.0863 17.6753V24.6643",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3226 15.4923V11.6342C18.3226 10.9784 18.8543 10.4467 19.5109 10.4467H19.6313C20.2871 10.4467 20.8188 10.9784 20.8188 11.6342V14.6529",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1712 15.4916L18.3226 19.8105",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1712 19.6034L18.3226 23.9224",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1712 23.7151L18.3226 28.0341",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1712 27.8269L18.3226 32.1459",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4437 35.5445L18.3226 36.2574",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1713 31.9386L23.0021 34.6846",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0933 46.5537H18.3227V41.7004C18.3227 41.3241 18.5733 40.9939 18.9357 40.8928L24.2531 39.4083C24.6752 39.2904 25.0933 39.6078 25.0933 40.0461V46.5537Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8472 32.0697H34.2447C34.0281 32.0697 33.8525 31.8941 33.8525 31.6776V30.3024C33.8525 30.0858 34.0281 29.9102 34.2447 29.9102H39.8472C40.0638 29.9102 40.2394 30.0858 40.2394 30.3024V31.6776C40.2394 31.8941 40.0638 32.0697 39.8472 32.0697Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8472 36.4137H34.2447C34.0281 36.4137 33.8525 36.2381 33.8525 36.0215V34.6464C33.8525 34.4298 34.0281 34.2542 34.2447 34.2542H39.8472C40.0638 34.2542 40.2394 34.4298 40.2394 34.6464V36.0215C40.2394 36.2381 40.0638 36.4137 39.8472 36.4137Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0977 40.8022H34.2445C34.028 40.8022 33.8524 40.6267 33.8524 40.4101V39.035C33.8524 38.8183 34.028 38.6428 34.2445 38.6428H36.0977C36.3143 38.6428 36.4899 38.8183 36.4899 39.035V40.4101C36.4899 40.6267 36.3143 40.8022 36.0977 40.8022Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.708 40.1188V46.5537",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_948_12312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.14af13a8bbdbac82b2c6c865a72777e4.svg";
export { ForwardRef as ReactComponent };